import { APIClient } from '@frontend/api-utils';
import { PurchaseOrder } from '@frontend/ugent/types';

const endpoint = '/ugent-api/v1';

export class PurchaseOrderClient extends APIClient {
    public static async fetchPurchaseOrder(accountId: string, poNumber: string): Promise<PurchaseOrder> {
        const response = await this.fetch(`${endpoint}/accounts/${accountId}/purchase-orders/${poNumber}`);
        return await this.handleResponse<PurchaseOrder>(response);
    }
}